<template>
  <div class="main_content">
    <van-nav-bar title="举报须知" fixed left-arrow @click-left="onClickLeft" />
    <h4>纪检监察信访举报须知:</h4>
    <!-- <h4>检举、控告、申诉人的权利和义务告知卡:</h4> -->
    <p>一、受理范围：</p>
    <p>1. 对全镇各级党组织、党员违反政治纪律、组织纪律、廉洁纪律、群众纪律、工作纪律、生活纪律等党的纪律行为提出检举控告。</p>
    <p>
      2. 对全镇监察对象（监察法规定的六类公职人员）不依法履职，违反秉公用权、廉洁从政从业以及道德操守等规定，涉嫌贪污贿赂、滥用职权、玩忽职守、权力寻租、利益输送、徇私舞弊以及浪费国家资财等职务违法犯罪行为提出检举控告。
    </p>
    <p>3. 对本镇党风廉政建设和反腐败工作提出批评建议。</p>
    <p>二、权利</p>
    <p>1. 各级党组织、党员对本区纪律检查机关所作的处理决定不服的， 有权提出申诉。</p>
    <p>
      2. 监察对象对本镇监察机关涉及本人的处理决定不服，有权提出申诉；被调查人及其近亲属对监察机关及其工作人员违反法律法规、侵害被调查人合法权益的行为，有权提出申诉。
    </p>
    <p>
      3. 提出检举、控告、申诉后，在一定期限内得不到答复，有权向受理机关提出询问，合理的要求给予答复。
    </p>
    <p>4. 有权要求与检举、控告案情有关或有牵连的承办人员回避。</p>
    <p>5. 对受理机关及承办人员的失职行为和其他违法行为，有权提出检举、控告。</p>
    <p>
      6. 检举、控告、申诉人因进行检举、控告、申诉，其合法权益受到威胁和侵害时，有权要求受理机关给予保护。
    </p>
    <p>三、义务</p>
    <p>1. 对所检举、控告、申诉的事实真实性负责。对借举报故意捏造事实、诬告陷害他人的或者以举报为名制造事端，干扰纪检监察机关正常工作的，依照有关规定严肃处理,构成犯罪的,移送司法机关依法处理。</p>
    <p>
      2. 检举、控告、申诉人必须遵守检举控告申诉工作的有关规定，维护社会秩序和工作秩序，不得缠访、闹访，不得滞留举报场所。如有违纪违法行为，必须接受纪检监察机关教育、劝告，直至承担纪律和法律责任。
    </p>
    <p>
      3. 检举、控告、申诉人必须接受纪检监察机关的正确处理意见，不得提出与纪律、法律相抵触的要求。
    </p>
    <!-- <h4>来访人员须知</h4>
    <p>1. 按"属地管理、分级负责"原则,逐级信访,依法信访,不要越级信访和一信多投。集体上访应推选代表(不超过5人)。</p>
    <p>
      2. 信访举报应客观公正、实事求是。对借举报故意捏造事
      实,诬告陷害他人的或者以举报为名制造事端，干扰纪检监察机关正常工作的,依照法律规定严肃处理。
    </p>
    <p>
      3. 来访人员应尽可能写清真实姓名，提供详细地址或联系方
      式,以便纪检监察机关联系和反馈办理情况。
    </p>
    <p>4. 来访人员应尽可能据实告知纪检监察机关被举报人的姓名、工作单位、违纪违法事实的具体情节和证据。</p>
    <p>
      5. 纪检监察机关受理信访举报后，来访人员应按工作人员的
      答复返回当地等待有关部门调查处理。
    </p>
    <p>6. 反映纪检监察机关受理范围外的问题，如土地违法、征地拆迁、劳动人事维权、组织人事、环境保护、历史遗留、涉法涉诉等问题,请向相关职能部门或通过当地信访部门反映有关情况， 纪检监察机关不予受理。</p>
    <p>
      7. 在信访过程中应遵守法律、法规，不得损害国家、社会、
      集体利益和其他公民的合法权利,自觉维护社会公共秩序和信访秩序,以及举报机关工作秩序,违者将追究相应的纪律和法律责任。
    </p>
    <p>
      8. 自觉维护来访接待秩序,保持室内外卫生,禁止躺卧、吸
      烟、拍照、录音、录像，注意保管随身物品。
    </p> -->
    <div class="check">
      <label>
        <input id="readme" type="checkbox" @click="toCheck()" />
        <span>我已阅读以上条款</span>
      </label>
    </div>
    <input type="submit" :class="{'active':active}" value="提交" class="tj" @click="toReport()" />
  </div>
</template>
<script>
import { NavBar } from "vant";
export default {
  components: {
    [NavBar.name]: NavBar
  },
  data() {
    return {
      active: false
    };
  },
  methods: {
    onClickLeft() {
      this.$router.push("/services");
    },
    toCheck() {
      if (event.target.checked) {
        this.active = true;
      } else {
        this.active = false;
      }
    },
    toReport() {
      if (this.active) {
        this.$router.push("/report");
      }
    }
  }
};
</script>
<style scoped>
.main_content {
  /* width: 90%; */
  padding: 1rem;
  background: white;
  text-align: left;
  margin-top: 1.5rem;
}
.main_content h4 {
  margin-bottom: 0.5rem;
  color: #d04a4c;
  font-size: 1.1rem;
}
.main_content p {
  text-align: justify;
  font-size: 1rem;
  margin: 0.5rem 0;
  color: #333333;
}
input {
  padding: 0.3rem 0.8rem;
  line-height: normal;
  font-size: 1rem;
  color: #444;
  border: 0.1rem solid rgba(0, 0, 0, 0.15);
}
.tj {
  border: none;
  background: none;
  display: block;
  margin: 1.8rem auto;
  background-color: rgb(204, 204, 204);
  /* background-color: #169bd5; */
  color: #ffffff;
  width: 6rem;
  height: 1.8rem;
  border-radius: 0.2rem;
  font-size: 0.8rem;
}
.active {
  background-color: #169bd5;
}
</style>


// WEBPACK FOOTER //
// src/page/notices.vue